import { Component, OnInit, Input } from '@angular/core';
import { FORMS, API, CODFUNC, GENERALES } from '../../../_config/strings';
import { NetworkHelperService } from '../../../_services/network-helper.service';
import {Subject} from 'rxjs/Subject';
import Swal from 'sweetalert2';
import swal from 'sweetalert2';
import { Usuario} from '../../../_model/Usuario';
import { Router, ActivatedRoute, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { Producto } from '../../../_model/Producto';
import { find } from 'rxjs/operator/find';
import { element } from 'protractor';

declare var $: any;
declare let L;

@Component({
  selector: 'app-material-apoyo-traspaso',
  templateUrl: './material-apoyo-traspaso.component.html',
  styleUrls: ['./material-apoyo-traspaso.component.scss']
})
export class MaterialApoyoTraspasoComponent implements OnInit {

  // @ViewChild('input') inputDinamico: ElementRef;

  public usuario: Usuario = new Usuario();

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dtTrigger2: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  CODFUNC: any;
  PAGE: any;
  GENERALES: any;

  Input = 0;
  ordenTrabajoId;
  materialApoyo;
  sucursalesPertenecientes;
  idSucursal;
  prueba;
  cantidadASolicitadar;
  sucursalOrigen;
  indiceReverse;
  llll;

  // array´s
  codigoProducto = [];
  materialASolicitar = [];
  arrayRespuestaSolicitud = [];
  arrayDeFisicoAObra = [];
  material = [];
  campos = [];
  test = [];
  arrayInforme = [];

  map;
  productosMaterial;
  arrayEnviarProductos = [];

  // booleano
  unaVez = true;

  constructor(
    private network: NetworkHelperService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.CODFUNC = CODFUNC;
    this.GENERALES = GENERALES;
    this.ordenTrabajoId = this.activatedRoute.snapshot.paramMap.get('idOrden');
    this.usuario = JSON.parse( localStorage.getItem('usuario') );
   }

  ngOnInit() {
    this.mapa();
    this.getSucursales();
    this.respuestaMaterialSolicitado();
    console.log( this.usuario );
  }

// la funcion recive 3 argumentos el primero son los valores de cada row producto
// el segundo es el indice del array indiceReverse
// el tercero es la pocision en el rowProducto
  flan(valores, index, posicion) {
   // console.log(valores);
    let suma: number = 0;
    for (const key in valores) {
      if (valores.hasOwnProperty(key)) {
        const element = valores[key];
        if (0 !== Number(key) && 1 !== Number(key) && 2 !== Number(key) && 'total' !== key) {
        suma = suma + element;
        }
      }
    }
    valores['total'] = suma;
    // console.log(suma);

    // se realiza una busqueda en los materiales que llegan del response por codigo comparandolo contra el rowProducto
  // console.log(index);
    if (index !== null) {
      let rowProductoModificado = this.productosMaterial.find(e => e.codigo == valores[1]);
      // console.log(rowProductoModificado);
      // se asigna el valor del indice de respuestaSolicitud en el array de materiales que llega del response 
      rowProductoModificado[index] = valores[posicion];
      // console.log(this.productosMaterial);
    }

  }

  getMaterial() {
    this.latlonSucu();

    document.getElementById('materialesApoyo').style.display = 'block';
    const jsonMaterial = {
      ordenTrabajoId: this.ordenTrabajoId,
      idSucursal: this.idSucursal
    };
    // console.log(jsonMaterial);
    this.network.callSecureService(
      this.API.user.almacenes  + '/' + this.API.user.apoyos,
      'POST',
      jsonMaterial)
      .subscribe((response: any) => {
        // console.log(response);
        this.materialApoyo = response.Mensaje;
        // console.log( this.materialApoyo );
        if (this.unaVez) {
        this.materialApoyo.forEach(element => {
          this.materialASolicitar.push({
            codigo: element.codigoProducto,
            descripcion: element.descripcion,
            cantidadApoyo: element.cantidadApoyo,
            ordenMaterialId: element.ordenMaterialId
          });
        });
        this.unaVez = false;
        this.dtTrigger.next();
        }
      }, err => {
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
        console.log(err);
      }
    );
  }

  getSucursales() {
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.apoyos + '/' + this.API.user.usuario + '/' + this.API.user.sucursales,
      'POST',
      {ordenTrabajoId: this.ordenTrabajoId})
      .subscribe((response: any) => {
        console.log(response);
        this.sucursalesPertenecientes = response.Mensaje.sucursalesApoyo;
        this.sucursalOrigen = response.Mensaje.sucursalOrigen;
        var myIcon = L.icon({
          iconUrl: '../../../assets/images/marker3.png',
          iconSize: [70, 40],
          iconAnchor: [36, 39],
          popupAnchor: [-3, -76],
          shadowUrl: '../../../assets/images/marker-shadow.png',
          shadowSize: [25, 35],
          shadowAnchor: [10, 32]
        });
        var myIcon2 = L.icon({
          iconUrl: '../../../assets/images/marker-icon.png',
          iconSize: [30, 52],
          iconAnchor: [15, 52],
          popupAnchor: [-3, -76],
          shadowUrl: '../../../assets/images/marker-shadow.png',
          // shadowSize: [68, 55],
          // shadowAnchor: [22, 55]
        });
        for (const suc of this.sucursalesPertenecientes) {
      if(suc.latitudSuc != this.sucursalOrigen.latitud)
      L.marker([suc.latitudSuc, suc.longitudSuc], {icon: myIcon}).addTo(this.map);
    }
      L.marker([this.sucursalOrigen.latitud, this.sucursalOrigen.longitud], {icon: myIcon2}).addTo(this.map);
      }, err => {
        console.log(err);
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
      }
    );
  }

  agregarProducto(producto) {
    const controlCantidad = producto.cantidadSolicitada;
    if ( controlCantidad === undefined ) {
      Swal('Atención', 'Debes de ingresa una cantidad para solicitar apoyo', 'warning');
    } else {
      document.getElementById('tituloSegundaTabla').style.display = 'block';
      document.getElementById('btnEnviarApoyo').style.display = 'block';
      this.test = [];
      const codigoProducto = producto.codigoProducto;
      // const descripcionProducto = producto.descripcion;
      const cantidadASolicitada: number = producto.cantidadSolicitada;
      const sucursalNombre = producto.nombreSucursalApoyo;

      this.materialASolicitar.forEach(element => {
        if (element.codigo == codigoProducto) {
          element[sucursalNombre] ? element[sucursalNombre] = element[sucursalNombre] + cantidadASolicitada : element[sucursalNombre] = cantidadASolicitada;
        } else {
          if (!element[sucursalNombre]) {
            element[sucursalNombre] = 0;
          }
        }
      });

      for (let values of this.materialASolicitar) {
        this.test.push(Object.values(values));
      }
      this.campos = Object.keys(this.materialASolicitar[0]);
      // console.log( this.materialASolicitar );
    }
  }

  solicitarApoyoSucursales () {
    const jsonMaterialASolicitar = {
      ordenTrabajoId: this.ordenTrabajoId,
      materialASolicitar: this.materialASolicitar
    };
    this.network.callSecureService(
      this.API.user.almacenes  + '/' + this.API.user.apoyos + '/' + this.API.user.generar,
      'POST',
      jsonMaterialASolicitar)
      .subscribe((response: any) => {
        // console.log(response);
        Swal( 'Correcto', 'Apoyo enviado correctamente', 'success' );
      }, err => {
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
        console.log(err);
      }
    );
  }

  reiniciar() {
    document.getElementById('tablaDinamica').style.display = 'none';
    this.arrayRespuestaSolicitud = [];
    this.respuestaMaterialSolicitado();
    document.getElementById('tablaDinamica').style.display = 'block';
  }

  respuestaMaterialSolicitado () {
    const json = {
      ordenTrabajoId: this.ordenTrabajoId
    };
    this.network.callSecureService(
      this.API.user.listar  + '/' + this.API.user.respuesta + '/' + this.API.user.material + '/' +  this.API.user.solicitado,
      'POST',
      json)
      .subscribe((response: any) => {
        console.log( response );
        if ( response.Mensaje == '' ) {
          document.getElementById('tablaRespuestaSucursales').style.display = 'none';
        }
        // this.arrayRespuestaSolicitud = response.Mensaje;
        // ñ
        this.productosMaterial = response.Mensaje;
        for (let values of response.Mensaje) {
          this.arrayRespuestaSolicitud.push(Object.values(values));
        }
        this.indiceReverse = Object.keys(response.Mensaje[0]);
        this.indiceReverse.push('total');
        for (let valor of this.arrayRespuestaSolicitud) {
          this.flan(valor, null, null);
        }
        this.dtTrigger2.next();
      }, err => {
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
        console.log(err);
      }
    );
  }

  validacion () {
    let bandera = 0;
    let rows = this.arrayRespuestaSolicitud.length;
    for ( const respuestaRecorrido of  this.arrayRespuestaSolicitud ) {
      if ( respuestaRecorrido['total'] !== undefined ) {
        if ( respuestaRecorrido['total'] < respuestaRecorrido[2] ) {
          // Swal
          swal({
            title: 'Te falta material',
            text: '¿Deseas enviar el apoyo incompleto?',
            type: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar'
          }).then((result) => {
            if (result.value) {
              this.enviarPeticionGerenteApoyo();
            }
          });
          // Swal
        } else {
          bandera = bandera + 1;
          if ( bandera === rows ) {
            this.enviarPeticionGerenteApoyo();
          }
        }
      }
    }
  }

  enviarPeticionGerenteApoyo() {
    const JSONMOVERAPOYOALMACEN = {
      materialesAutorizados: this.productosMaterial,
      ordenTrabajoId : Number(this.ordenTrabajoId)
    };
    console.log(JSONMOVERAPOYOALMACEN);
    this.network.callSecureService(
      this.API.user.apoyos + '/' + this.API.user.guarda + '/' + this.API.user.cantidad + '/' + this.API.user.aceptada,
      'POST',
      JSONMOVERAPOYOALMACEN
    ).subscribe((response: any) => {
      console.log( response );
      Swal( 'Correcto', response.Mensaje, 'success' );
    }, err => {
      console.log(err);
    });
  }

  mapa() {

    // declaracion del mapa
    this.map = L.map('map', { /*var map será nuestra variable global y principal, aquí la estamos seteando, asignándole L.map qie es el objeto vacío de la clase Leaflet que estamos llamando y enviándole el “map” que es el ID de nuestro DIV anteriormente creado. */
      dragging: true,
      touchZoom: true,
      scrollWheelZoom: true,
      doubleClickZoom: true,
      boxZoom: true,
      tap: true,
      keyboard: false,
      contextmenu: true,
      contextmenuWidth: 140,
      contextmenuItems: [{
          text: 'Centrar el mapa aqui',
          callback: centerMap
      }
        , '-', {
          text: 'Zoom +',
          // icon: 'images/zoom-in.png',
          callback: zoomIn
      }, {
          text: 'Zoom -',
         // icon: 'images/zoom-out.png',
          callback: zoomOut
      }
      ],
      fullscreenControl: true,
      fullscreenControlOptions: {
          position: 'topleft'
        }
    }).setView([22.8196273667, -99.9503588558], 5);

    // el tile layer son las capas, en este caso es una capa de mapa(direcciones)
    L.tileLayer('http://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', { /*Usamos el servicio como Tile para desplegar el mapa dependiendo del mosaico en pantalla.*/
      maxZoom: 19,
      maxNativeZoom: 19,
      zoomDelta: 0.25,
      zoomSnap: 0,
      attribution: 'Map data &copy; OpenStreetMap contributors' // opciones
    }).addTo(this.map); // aquí agregamos el mapa base (WMS) a el map (que es nuestra objeto map)

    // es el icono para agregar marcadores
    var myIcon = L.icon({
      iconUrl: '../../../assets/images/marker-icon.png',
      iconSize: [30, 55],
      // iconAnchor: [22, 55],
      popupAnchor: [-3, -76],
      shadowUrl: '../../../assets/images/marker-shadow.png',
      // shadowSize: [25, 50],
      // shadowAnchor: [20, 50]
    });
    // El siguinte modulo es para el buscador, en base a librerias y una API externa es como se buscan las direcciones
  
    // Las siguientes son funciones para el menu de contexto

    // centrar el mapa
    function centerMap (e) {
      this.map.panTo(e.latlng);
    }
    // colocar el marcador icono
    

    // Le da zoom con click derecho
    function zoomIn (e) {
      this.map.zoomIn();
    }

    // Quita zoom en dos puntos
    function zoomOut (e) {
      this.map.zoomOut();
    }
  }

  latlonSucu() {
    let sucursal = this.sucursalesPertenecientes.find(e => e.idSucursal == this.idSucursal);
    // this.map.setView([sucursal.latitudSuc, sucursal.longitudSuc], 7);
    this.map.eachLayer(function(layer) {
     // console.log(layer);
      if (layer._latlngs) {
        console.log(layer);
        layer.remove();
      }
    });
    let polyline = L.polyline([[this.sucursalOrigen.latitud, this.sucursalOrigen.longitud], [sucursal.latitudSuc, sucursal.longitudSuc]], {color: 'red'}).addTo(this.map);
    this.map.setView([sucursal.latitudSuc, sucursal.longitudSuc], 6.5, {animate: true, duration: 1.5, easeLinearity: 2});
  }

  informe () {
    const JSONINFORME = {
      ordenTrabajoId: this.ordenTrabajoId
    };
    this.network.callSecureService(
      this.API.user.apoyos + '/' + this.API.user.informe + '/' + this.API.user.sucursal,
      'POST',
      JSONINFORME
    ).subscribe((response: any) => {
      this.arrayInforme = response.Mensaje;
      console.log( this.arrayInforme );
    }, err => {
      console.log( err );
    });
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/material-apoyo-traspaso/material-apoyo-traspaso.component.ts